// extracted by mini-css-extract-plugin
export var carrierInformation = "wjUwL8vvWReEmPOB3J6x";
export var name = "rJVjHBjXkl85JwLhFsH4";